import makeApiCall from "./axiosIndex";
const toolMasterApis = {
  toolTypesList: async (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchToolsAndMachineryTypesDropDown",
      method: "get",
    });
  },

  fetchToolWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchToolAndMachineriesWithPagination",
      method: "get",
      params,
    });
  },
  fetchToolDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchToolsAndMachineryDropDown",
      method: "get",
    });
  },

  fetchToolById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchToolById`,
      method: "get",
      params: { id },
    });
  },

  updateToolById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateToolById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createTool: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createNewToolAndMachinery`,
      method: "post",
      data,
    });
  },

  deleteToolyId: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteToolById",
      method: "delete",
      params: { id },
    });
  },

  // status
  allowActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/activateToolById`,
      params: { id },
    }),

  removeActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/inActivateToolById`,
      params: { id },
    }),
};

export default toolMasterApis;
